import React from 'react';
import { Reveal } from '../Reveal';
import { CTAButton } from '../CTAButton';
import { SparkleIcon } from 'lucide-react';
import { GlowBorder } from '../GlowBorder';
export const MidCTA: React.FC = () => <section className="relative bg-navy-deep py-20 lg:py-24 overflow-hidden" data-id="element-287">
    <div className="absolute inset-0 pointer-events-none" style={{
    background: 'radial-gradient(ellipse at center, rgba(212,175,122,0.1), transparent 65%)'
  }} data-id="element-288" />

    <div className="relative max-w-4xl mx-auto px-6 lg:px-8" data-id="element-289">
      <Reveal data-id="element-290">
        <GlowBorder intensity="subtle" duration={10} data-id="element-291">
          <div className="bg-gradient-to-br from-navy-mid/70 to-navy-deep/70 backdrop-blur-sm p-8 lg:p-10 flex flex-col md:flex-row items-center gap-8 md:gap-10 relative overflow-hidden rounded-2xl" data-id="element-292">
            <div className="absolute -top-20 -left-20 w-60 h-60 rounded-full opacity-20 blur-3xl" style={{
            background: 'radial-gradient(circle, rgba(212,175,122,0.7), transparent 70%)'
          }} data-id="element-293" />

            <div className="relative flex-1 text-center md:text-left" data-id="element-294">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-3" data-id="element-295">
                <SparkleIcon className="w-3.5 h-3.5 text-gold" strokeWidth={1.5} data-id="element-296" />
                <span className="text-[10px] uppercase tracking-eyebrow text-gold" data-id="element-297">
                  El primer paso
                </span>
              </div>
              <h3 className="font-serif text-2xl lg:text-3xl text-ivory leading-snug" style={{
              fontWeight: 400
            }} data-id="element-298">
                Diez claves. Un mismo camino.
                <br className="hidden lg:block" data-id="element-299" />
                <span className="italic gold-text" data-id="element-300">
                  {' '}
                  Tu equilibrio te espera.
                </span>
              </h3>
            </div>
            <div className="relative flex-shrink-0" data-id="element-301">
              <CTAButton size="md" trustLine={null} data-id="element-302">
                Comenzar el viaje hoy
              </CTAButton>
            </div>
          </div>
        </GlowBorder>
      </Reveal>
    </div>
  </section>;